import { useState } from 'react';
import MainForm from '~/modules/identification/MainForm.tsx';
import AssetManagerVerification from '../../components/AssetManagerVerification/AssetManagerVerification.tsx';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader.tsx';

export default function AssetManagerForm() {
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <FullPageLoader />}
      {!isVerified && (
        <AssetManagerVerification
          onSuccess={() => setIsVerified(true)}
          offLoading={() => setIsLoading(false)}
        />
      )}
      {isVerified && <MainForm />}
    </>
  );
}
